import {
  IDynamicItem,
  IDynamicInput,
} from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';
import { Product, ProductPriceRanges } from 'graphql-api/gql-api-interfaces';
import {
  recommendationItemClickedEventHandler,
  openConfigStripEventHandler,
  recommendationItemShownEventHandler,
} from '../events';
import { LoadableItemView } from '../types/item-view';
import { SingleProductDataType } from '../types/single-product-data-type';

export function productCard() {
  const pCard: IDynamicItem = {
    contentTypeId: 'dynamic-elements-product-card',
    data: {
      _product: {
        provider: 'parent',
        property: 'productData',
        transform: function (productData: SingleProductDataType): Product {
          return productData.product;
        }.toString(),
      },
      isClicked: {
        provider: 'self',
        property: 'cardClick',
        startWith: {
          value: false,
        },
        transform: function (cardClick: string): boolean {
          return Boolean(cardClick);
        }.toString(),
      },
    },
    inputs: {
      groupVariants: {
        provider: 'id:root',
        property: 'imgToUse',
        transform: function (imgToUse: string): boolean {
          return imgToUse.includes('article');
        }.toString(),
      },
      product: {
        provider: 'self',
        property: '_product',
      },
      prices: {
        provider: 'self',
        property: '_product',
        transform: function (product: Product): ProductPriceRanges[] {
          return product?.priceRanges;
        }.toString(),
      },
    },
    outputs: {
      cardClick: [
        recommendationItemClickedEventHandler(
          { provider: 'id:root', property: 'panelName' },
          { provider: 'id:root', property: 'panelTrackingId' },
          { provider: 'parent', property: 'productData' },
        ),
        openConfigStripEventHandler('parent', 'productData'),
      ],
    },
    styles: {
      style: {
        height: '100%',
      },
    },
  };

  const pCardWrapper: IDynamicItem = {
    id: 'scrollable-item-pcard',
    contentTypeId: 'dynamic-collections-renderer',
    data: {
      productData: undefined as unknown as IDynamicInput, // Will be injected by array renderer
    },
    styles: {
      classes: ['d-block', 'p-card'],
      style: {
        width: '300px',
        height: '500px',
        margin: '0 10px',
        __multiple__: {
          provider: 'id:root',
          property: 'singleItemStyle',
        },
      },
    },
    children: [pCard],
    eventHandlers: {
      onVisibleOnce: [
        recommendationItemShownEventHandler(
          {
            provider: 'id:root',
            property: 'panelName',
          },
          {
            provider: 'id:root',
            property: 'panelTrackingId',
          },
          { provider: 'id:root', property: 'productData' },
        ),
      ],
    },
  };

  const loadingSkeleton: IDynamicItem = {
    contentTypeId: 'dynamic-collections-renderer',
    styles: {
      classes: ['d-block', 'p-card', 'loading-skeleton'],
      style: {
        'background-color': '#f5f5f5',
        __multiple__: {
          provider: 'id:root',
          property: 'singleSkeletonStyle',
        },
      },
    },
  };

  const loadableItemView: LoadableItemView = {
    itemContentType: pCardWrapper,
    loadingSkeletonContentType: loadingSkeleton,
  };

  return loadableItemView;
}
